const state = {
    type: null,
    n_type:null,
    message: null
};

const actions = {
    success({ commit }, message) {
        commit('success', message);
    },
    error({ commit }, message) {
        commit('error', message);
    },
    warning({ commit }, message) {
        commit('warning', message);
    },
    info({ commit }, message) {
        commit('info', message);
    },
    clear({ commit }) {
        commit('clear');
    }
};

const mutations = {
    success(state, message) {
        state.type = 'k-notification-success';
        state.n_type='success';
        state.message = message;
    },
    error(state, message) {
        state.type = 'k-notification-error';
        state.n_type='error';
        state.message = message;
    },
    info(state, message) {
        state.type = 'k-notification-info';
        state.n_type='info';
        state.message = message;
    },
    warning(state, message) {
        state.type = 'k-notification-warning';
        state.n_type='warning';
        state.message = message;
    },
    clear(state) {
        state.type = null;
        state.n_type=null;
        state.message = null;
    }
};

export const alert = {
    namespaced: true,
    state,
    actions,
    mutations
};
